import React from 'react';
import ESLogo from '../../../media/logo.png';

const ConclusionPage = props => {   

    return(
        <div id='rmis-report-notes' className="rmis-report-page">
            <div className="report-page-footer" style={{width:'7.5in', marginTop:'9.5in'}}>
                <img src={ESLogo} className="report-page-logo"/>
                <div className="field-spacer-md"></div>
                <p className="report-page-number">page {props.page}</p>
            </div>
            
            <h4 style={{fontWeight:'bold', fontSize:'1.78rem', color:'rgb(8,114,182)'}}>{`${props.name}`}.</h4>
            <br/>

            <p className="text-muted-dark">If you have any questions about this report, next steps or other conservation measures you are considering, contact Enviro-Stewards at 519-578-5100, or reach out to the staff member(s) you are in contact with.</p>

            <br/>
        </div>
    );
}

export default ConclusionPage;